import { helper } from '@ember/component/helper';
import formatErrorUtil from 'cio/utils/errors/format-error';
import { htmlSafe } from '@ember/template';

function extractErrorDetail(error) {
  if (typeof error === 'string') {
    return error;
  } else if (typeof error === 'object' && 'detail' in error) {
    return error.detail;
  }

  return 'Unknown error';
}

export function formatError([error], { variant = null, type = null, deliveryState = null, fallbackText = '' }) {
  try {
    return htmlSafe(formatErrorUtil(error, type, variant, deliveryState, fallbackText));
  } catch {
    return extractErrorDetail(error);
  }
}

export default helper(formatError);
